module.exports = __webpack_public_path__ + "static/img/zixun2.500bd17.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/zixun2.png
// module id = 6x9E
// module chunks = 1